import {
  Checkbox,
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import Popup from "../../../components/common/model/Popup";
import React, { useEffect, useMemo, useState } from "react";
import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import useStyles from "../../../components/common/model/styles";
import { roleAllFields } from "./userAllFields";
import FormField from "../../../components/common/FormField";
import {
  addRoleAction,
  setAddRoleResponse,
} from "../../../store/reducers/roleSlice";
import { useDispatch } from "react-redux";
import Validation from "../../../utils/Validation";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { useSelector } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import ResetFormAlert from "./ResetFormAlert";

interface ManageRoleProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectRole: any; // Adjust type as per your requirement
}

interface RoleDetail {
  role: string;
  description: string;
  permissions: {
    [key: string]: {
      create: boolean;
      read: boolean;
      update: boolean;
      delete: boolean;
    };
  };
  [key: string]: any;
}

const initialRoleDetail: RoleDetail = {
  role: "",
  description: "",
  permissions: {
    "Communication:Email": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Communication:Sms": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "File Upload": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Invoice: { create: false, read: false, update: false, delete: false },
    Lead: { create: false, read: false, update: false, delete: false },
    "Lead:Archive": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Lead:Completion": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Lead:Confirmation": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Lead:Estimate": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Lead:Job": { create: false, read: false, update: false, delete: false },
    "Lead:Log": { create: false, read: false, update: false, delete: false },
    "Lead:Provisional": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Lead:Quotation": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Lead:Survey": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Notification: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Operations: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Payment: { create: false, read: false, update: false, delete: false },
    Setting:{ create: false, read: false, update: false, delete: false },
    "Setting:Communications": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Company": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Customer":{create: false, read: false, update: false, delete: false},
    "Setting:Document": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Feedback": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Financials": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Owner": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Referrer": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Role": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Sales": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Staff": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Setting:Worker And Vehicle": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Survey Tasks": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Surveyor:{create: false, read: false, update: false, delete: false},
    Task: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    "Work Diary": {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
  },
};

const ManageRole: React.FC<ManageRoleProps> = (props) => {
  const [roleDetail, setRoleDetail] = useState<RoleDetail>(initialRoleDetail);
  const dispatch = useDispatch();
  const { isAddRoleSuccess } = useSelector((state: any) => state.role);
  const { selectRole, onHide, open, title } = props;
  const classes = useStyles();
  const [fullWidth] = useState(true);
  const [maxWidth] = useState<"sm" | "xs" | "md" | "lg" | "xl" | false>("md"); // Adjust the type definition
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [isPermissionError, setIsPermissionError] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [checkPermission, setCheckPermission] = useState(false);

  const resetForm = React.useCallback(() => {
    setRoleDetail(initialRoleDetail); // Reset the form state to initial values
    setIsPermissionError(false);
    setIsValid(false);
    setCheckPermission(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  }, [dispatch]);

  useEffect(() => {
    if (isAddRoleSuccess) {
      resetForm();
      dispatch(setAddRoleResponse(false));
    }
  }, [dispatch, isAddRoleSuccess, resetForm]);
  const hideHandler = () => {
    setRoleDetail(initialRoleDetail);
    setCheckPermission(false);
    setIsPermissionError(false);
    setIsValid(false);
    resetForm();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator(); // Reset all validation errors
    onHide();
  };
  console.log("selectedRole in ManageRole-", selectRole);
 useEffect(() => {
  if (selectRole && selectRole.modules) {
    const updatedPermissions = JSON.parse(
      JSON.stringify(initialRoleDetail.permissions)
    );

    selectRole.modules.forEach((module: any) => {
      const moduleName = module?.module_name?.trim();

      // case insensitive match
      const matchedKey = Object.keys(updatedPermissions).find(
        (key) => key.toLowerCase() === moduleName.toLowerCase()
      );

      if (matchedKey) {
        module.permissions.forEach((permission: any) => {
          if (updatedPermissions[matchedKey][permission] !== undefined) {
            updatedPermissions[matchedKey][permission] = true;
          }
        });
      }
    });

    setRoleDetail({
      role: selectRole.role || "",
      role_id: selectRole.role_id || "",
      description: selectRole.description || "",
      permissions: updatedPermissions,
    });

    setCheckPermission(true);
  } else {
    setRoleDetail(initialRoleDetail);
    setCheckPermission(false);
  }
}, [selectRole]);

  useEffect(() => {
    if (!open) {
      setRoleDetail(initialRoleDetail);
      setCheckPermission(false);
    }
  }, [open]);

  const permissionTypes = ["create", "read", "update", "delete"] as const;

  const formatPermissionKey = (key: string) => {
    return key
      .replace(/_/g, " ") // Replace underscores with spaces
      .split(" ") // Split the string into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" "); // Join the words back together with spaces
  };

  const groupedPermissions = useMemo(() => {
    const groups: Record<string, string[]> = {};
    Object.keys(roleDetail.permissions).forEach((moduleName) => {
      const groupName = moduleName.split(":")[0].trim();
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(moduleName);
    });
    return groups;
  }, [roleDetail.permissions]);

  const getGroupPermissionStatus = (
    group: string,
    permissionType: (typeof permissionTypes)[number],
  ) => {
    const modules = groupedPermissions[group] || [];
    const checkedCount = modules.filter(
      (moduleName) => roleDetail.permissions[moduleName]?.[permissionType],
    ).length;
    return {
      checked: modules.length > 0 && checkedCount === modules.length,
      indeterminate: checkedCount > 0 && checkedCount < modules.length,
    };
  };

  const isPermissionDisabled = (
    moduleName: string,
    permissionType: (typeof permissionTypes)[number],
  ) => {
    if (selectRole?.role === "Surveyor" && moduleName === "Surveyor") {
      return true;
    }
    if (
      selectRole?.role === "Surveyor" &&
      permissionType === "read" &&
      ["Lead", "Lead:Survey", "Surveyor"].includes(moduleName)
    ) {
      return true;
    }
    return false;
  };

  const handleGroupPermissionChange = (
    group: string,
    permissionType: (typeof permissionTypes)[number],
    value: boolean,
  ) => {
    setRoleDetail((prevDetail) => {
      const updatedPermissions = { ...prevDetail.permissions };
      (groupedPermissions[group] || [])
        .filter(
          (moduleName) => !isPermissionDisabled(moduleName, permissionType),
        )
        .forEach((moduleName) => {
          updatedPermissions[moduleName] = {
            ...updatedPermissions[moduleName],
            [permissionType]: value,
          };
        });
      return {
        ...prevDetail,
        permissions: updatedPermissions,
      };
    });
    setCheckPermission(true);
  };

  const handlePermissionChange = (
    module: string,
    permission: string,
    value: boolean,
  ) => {
    setRoleDetail((prevDetail) => ({
      ...prevDetail,
      permissions: {
        ...prevDetail.permissions,
        [module]: {
          ...prevDetail.permissions[module],
          [permission]: value,
        },
      },
    }));
    setCheckPermission(true);
  };

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    role: roleDetail?.role,
  });

  useEffect(() => {
    if (checkPermission) {
      const isAnyPermissionSelected = (): boolean => {
        return Object.values(roleDetail.permissions).some(
          (permissions) =>
            permissions.create ||
            permissions.read ||
            permissions.update ||
            permissions.delete,
        );
      };

      setIsValid(isAnyPermissionSelected());

      if (checkPermission && isValid) {
        setIsPermissionError(true);
      } else {
        setIsPermissionError(true);
      }
      setCheckPermission(false);
    }
  }, [roleDetail.permissions, checkPermission, isValid]);

 const handleSubmit = (event: any) => {
  event.preventDefault();

  checkValidator();

  const modules = Object.keys(roleDetail.permissions)
    .map((module) => {
      const permissions = Object.keys(roleDetail.permissions[module]).filter(
        (perm) =>
          roleDetail.permissions[module][
            perm as keyof RoleDetail["permissions"][string]
          ],
      );

      return {
        module_name: module,
        permissions,
      };
    })
    .filter((module) => module.permissions.length > 0);

  const payload = {
    role: roleDetail.role,
    role_id: roleDetail.role_id,
    description: roleDetail.description,
    modules: modules,
  };

  const isAnyPermissionSelected = Object.values(roleDetail.permissions).some(
    (permissions) =>
      permissions.create ||
      permissions.read ||
      permissions.update ||
      permissions.delete,
  );

  if (!isAnyPermissionSelected) {
    setIsPermissionError(true);
    return;
  }

  if (!isError() && error !== null) {
    dispatch(addRoleAction(payload));
  }
};

  useEffect(() => {
    if (isActionCalled) {
      const modules = Object.keys(roleDetail.permissions)
        .map((module) => {
          const permissions = Object.keys(
            roleDetail.permissions[module],
          ).filter(
            (perm) =>
              roleDetail.permissions[module][
                perm as keyof RoleDetail["permissions"][string]
              ],
          );

          return {
            module_name: module,
            permissions,
          };
        })
        .filter((module) => module.permissions.length > 0);

      const payload = {
        role: roleDetail.role,
        role_id: roleDetail.role_id,
        description: roleDetail.description,
        modules: modules,
      };

      if (!isError() && error !== null && isActionCalled && isValid) {
        dispatch(addRoleAction(payload));
      }
      setIsActionCalled(false);
    }
  }, [
    dispatch,
    error,
    isError,
    isActionCalled,
    isValid,
    roleDetail.description,
    roleDetail.permissions,
    roleDetail.role,
    roleDetail.role_id,
  ]);

  const handleInputChange = (field: string, value: any) => {
    setRoleDetail((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    resetValidator(field);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const handleClear = React.useCallback(() => {
    // Reset the roleDetail state to initial values
    setRoleDetail(initialRoleDetail);

    // Clear all validation errors
    resetAllValidator();

    // Reset other states as needed
    setIsClickReset(false);
    setAlertModelShow(false);

    // Optionally reset the form to reflect the initial state
    if (selectRole?.role) {
      // Processing the selected role's data if needed (this part may depend on your actual requirements)
      const updatedPermissions = { ...initialRoleDetail.permissions };
      selectRole.modules.forEach((module: any) => {
        if (updatedPermissions[module.module_name]) {
          module.permissions.forEach(
            (permission: keyof (typeof updatedPermissions)[string]) => {
              updatedPermissions[module.module_name][permission] = true;
            },
          );
        }
      });

      // Set the form data based on the selected role
      setRoleDetail({
        role: selectRole.role,
        description: selectRole.description,
        permissions: updatedPermissions,
      });
    } else {
      // If no role is selected, reset the form to its initial state
      setRoleDetail(initialRoleDetail);
    }

    // Reset any other necessary states
    // Reset validation states
    resetAllValidator();
    setIsClickReset(false);
    setAlertModelShow(false);
    setIsPermissionError(false);
    setIsValid(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  }, [dispatch, resetAllValidator, selectRole]);

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset, handleClear]);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "10px" }}>
          <DialogContentText>
            <Notification />
            <Grid
              container
              spacing={0.5}
              sx={{
                background: "#E5F4F1",
                border: "1px solid #CFCFCF",
                borderRadius: "5px",
                padding: "10px",
              }}
            >
              {roleAllFields.map((field, i) => {
                return (
                  <FormField
                    key={i}
                    onPaste={(e) => e.preventDefault()}
                    onKeyDown={(event: any) => {
                      console.log(
                        "event log-",
                        event,
                        event.target.value + event.key,
                      );
                      if (
                        event.keyCode === 8 ||
                        event.keyCode === 9 ||
                        event.keyCode === 37 ||
                        event.keyCode === 38 ||
                        event.keyCode === 39 ||
                        event.keyCode === 40 ||
                        event.keyCode === 18 ||
                        event.keyCode === 17 ||
                        event.ctrlKey
                      )
                        return event;
                      if (
                        field?.patternAllowed &&
                        !field?.patternAllowed.test(event.key)
                      ) {
                        event.preventDefault();
                      } else if (
                        field?.patternAllowed &&
                        !field?.patternAllowed.test(
                          event.target.value + event.key,
                        )
                      ) {
                        event.preventDefault();
                      }
                    }}
                    {...{
                      ...field,
                      ...{
                        disabled:
                          field?.id === "role" &&
                          selectRole?.role === "Surveyor"
                            ? true
                            : false,
                        variant: "outlined", // Adding this variant prop
                        inSingleGridForm: true,
                        isNonMarginTop: true,
                        InputProps: {
                          ...(field?.inputProps && field?.inputProps),
                          sx: { height: "36px" },
                          // ...(selectRole && { disabled: field?.editReadOnly }),
                          autocomplete: "user-new-field",
                        },
                        value: roleDetail ? roleDetail[field.id] : "",
                        // onBlur: onBlurAction,

                        onChange: (e: any) =>
                          handleInputChange(field.id, e.target.value), // Call onChange prop
                        error: error && error[field?.id],
                      },
                    }}
                  />
                );
              })}
            </Grid>
            <Grid container spacing={2} style={{ marginTop: "6px" }}>
              <Grid
                item
                xs={12}
                sm={4}
                style={{
                  border: "2px solid #dbdbdb",
                  borderTopLeftRadius: "5px",
                  borderBottomLeftRadius: "5px",
                  padding: "8px",
                  background: "#E5F4F1",
                }}
              >
                <Typography
                  style={{
                    color: "#333333",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  Permissions
                  <span style={{ color: "#ff0017", fontWeight: 500 }}>*</span>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                style={{
                  background: "#E5F4F1",
                  padding: "6px 8px",
                  border: "1px solid #CFCFCF",
                  borderTopRightRadius: "5px",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                <Grid container alignItems="center">
                  <Grid
                    item
                    xs={3}
                    sx={{ textAlign: "center", fontSize: "12px" }}
                  >
                    Create
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ textAlign: "center", fontSize: "12px" }}
                  >
                    Read
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ textAlign: "center", fontSize: "12px" }}
                  >
                    Update
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ textAlign: "center", fontSize: "12px" }}
                  >
                    Delete
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  background: "#fff",
                  paddingBottom: "6px",
                  border: checkPermission
                    ? isPermissionError && isValid
                      ? "1px solid #dbdbdb"
                      : "1px solid #d32f2f"
                    : "1px solid #dbdbdb",
                  borderTopLeftRadius: "5px",
                  paddingLeft:'0px'
                }}
              >
                {roleDetail.permissions &&
                  Object.keys(groupedPermissions).map((group) => (
                    <Grid container key={group} sx={{ mb: 1 }}>
                      <Grid
                        container
                        alignItems="center"
                        sx={{
                          background: "#f6f7f8",
                          borderBottom: "1px solid #dbdbdb",
                          padding: "8px 0",
                          minHeight: "36px",
                          paddingLeft:'8px'
                        }}
                      >
                        <Grid item xs={4}>
                          <Typography sx={{ fontWeight: 700,fontSize:"14px" }}>
                            {formatPermissionKey(group)} Group
                          </Typography>
                        </Grid>
                        {permissionTypes.map((permissionType) => {
                          const status = getGroupPermissionStatus(
                            group,
                            permissionType,
                          );
                          return (
                            <Grid
                              item
                              xs={2}
                              key={permissionType}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                
                              }}
                            >
                              <Checkbox
                                size="small"
                                sx={{ padding: "0px" }}
                                checked={status.checked}
                                indeterminate={status.indeterminate}
                                disabled={(
                                  groupedPermissions[group] || []
                                ).every((moduleName) =>
                                  isPermissionDisabled(
                                    moduleName,
                                    permissionType,
                                  ),
                                )}
                                onChange={(e) =>
                                  handleGroupPermissionChange(
                                    group,
                                    permissionType,
                                    e.target.checked,
                                  )
                                }
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                      {(groupedPermissions[group] || []).map((perm) => (
                        <Grid
                          container
                          key={perm}
                          alignItems="center"
                          sx={{
                            borderBottom: "1px solid #f0f0f0",
                            padding: "8px 0",
                          }}
                        >
                          <Grid item xs={4} sx={{fontSize:'14px',paddingLeft:'8px'}}>
                            {formatPermissionKey(perm)}
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingLeft:'8px'
                            }}
                          >
                            <Checkbox
                              disabled={isPermissionDisabled(perm, "create")}
                              sx={{ padding: "0px" }}
                              checked={roleDetail.permissions[perm].create}
                              onChange={(e) =>
                                handlePermissionChange(
                                  perm,
                                  "create",
                                  e.target.checked,
                                )
                              }
                              name={`${perm}-create`}
                              size="small"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingLeft:'8px'
                            }}
                          >
                            <Checkbox
                              disabled={isPermissionDisabled(perm, "read")}
                              sx={{ padding: "0px" }}
                              checked={roleDetail.permissions[perm].read}
                              onChange={(e) =>
                                handlePermissionChange(
                                  perm,
                                  "read",
                                  e.target.checked,
                                )
                              }
                              name={`${perm}-read`}
                              size="small"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                           sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingLeft:'6px'
                            }}
                          >
                            <Checkbox
                              disabled={isPermissionDisabled(perm, "update")}
                              sx={{ padding: "0px" }}
                              checked={roleDetail.permissions[perm].update}
                              onChange={(e) =>
                                handlePermissionChange(
                                  perm,
                                  "update",
                                  e.target.checked,
                                )
                              }
                              name={`${perm}-update`}
                              size="small"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingLeft:'0px'
                            }}
                          >
                            <Checkbox
                              disabled={isPermissionDisabled(perm, "delete")}
                              sx={{ padding: "0px" }}
                              checked={roleDetail.permissions[perm].delete}
                              onChange={(e) =>
                                handlePermissionChange(
                                  perm,
                                  "delete",
                                  e.target.checked,
                                )
                              }
                              name={`${perm}-delete`}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};
export default ManageRole;
